import axios from "@/api/axios";

function getCounters() {
  return axios.get("services/v1.0/services/counters/");
}

function saveCounters({ data, headers = {} }) {
  return axios.post("services/v1.0/services/counters/", data, { headers });
}
export default {
  getCounters,
  saveCounters
};
